import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {HideLoader, ShowLoader} from './loader.actions';


export interface LoaderStateModel {
  loading: boolean;
}

@State<LoaderStateModel>({
  name: 'LoaderStateModel',
  defaults: {
    loading: false
  },
})
@Injectable()
export class LoaderState {

  private loaderTimeout;

  @Selector()
  static loading({loading}: LoaderStateModel): boolean {
    return loading;
  }

  @Action(ShowLoader)
  showLoader(
    {patchState}: StateContext<LoaderStateModel>,
    {showTimeout}: ShowLoader
  ): void {
    this.loaderTimeout = setTimeout(() => {
      patchState({
        loading: true,
      });
    }, showTimeout);
  }

  @Action(HideLoader)
  hideLoader(
    {patchState}: StateContext<LoaderStateModel>
  ): void {
    clearTimeout(this.loaderTimeout);
    patchState({
      loading: false,
    });
  }

}
